import { useEffect, useState } from "react";
import { useAuth } from "../lib/AuthProvider";

export function useIntegrationAccess() {
  const { supabase, tenant, profile } = useAuth();
  const [state, setState] = useState({ loading: true, available: false, integrations: [] });

  useEffect(() => {
    let active = true;
    if (!tenant?.id || !profile?.role || !supabase?.functions?.invoke) {
      setState({ loading: false, available: false, integrations: [] });
      return () => { active = false; };
    }
    setState((current) => ({ ...current, loading: true }));
    supabase.functions.invoke("tenant-integrations", { body: { action: "list" } }).then(({ data, error }) => {
      if (!active) return;
      setState({
        loading: false,
        available: !error && data?.available === true,
        integrations: !error && Array.isArray(data?.integrations) ? data.integrations : [],
        error: error || (data?.error ? new Error(data.error) : null),
      });
    });
    return () => { active = false; };
  }, [profile?.role, supabase, tenant?.id]);

  return state;
}
